import React, { FC } from 'react';
import cs from 'classnames';
import s from './SearchSuggestionButton.scss';

interface SearchSuggestionButtonProps {
  children?: React.ReactNode;
  onClick: () => void;
  isActive?: boolean;
}

export const SearchSuggestionButton: FC<SearchSuggestionButtonProps> = ({
  onClick,
  isActive,
  children,
}) => {
  return (
    <button
      onClick={onClick}
      className={cs(s.button, {
        [s.active]: isActive,
      })}
    >
      {children}
    </button>
  );
};
